import { useEffect, useState } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { Toaster } from "@/components/ui/sonner";
import { CartProvider } from "@/context/CartContext";
import { autoDetectCurrency } from "@/lib/currency";
import CartDrawer from "@/components/CartDrawer";
import SplashScreen from "@/components/SplashScreen";
import Home from "@/pages/Home";
import ProductPage from "@/pages/ProductPage";
import StatusPage from "@/pages/StatusPage";
import CustomerPortal from "@/pages/CustomerPortal";
import PaymentSuccess from "@/pages/PaymentSuccess";
import BankPending from "@/pages/BankPending";
import CryptoPay from "@/pages/CryptoPay";
import ResellerLogin from "@/pages/ResellerLogin";
import ResellerDashboard from "@/pages/ResellerDashboard";
import PaymentCancel from "@/pages/PaymentCancel";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import TermsPage from "@/pages/TermsPage";
import PrivacyPage from "@/pages/PrivacyPage";

function App() {
  const [splash, setSplash] = useState(true);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
    };
  }, []);

  useEffect(() => {
    const t = setTimeout(() => setSplash(false), 3000);
    autoDetectCurrency();
    return () => clearTimeout(t);
  }, []);

  return (
    <CartProvider>
      <BrowserRouter>
        <div className="min-h-screen bg-[#050B18] text-slate-100 font-body relative">
          <div className="noise-overlay" aria-hidden="true" />
          <AnimatePresence>{splash && <SplashScreen key="splash" />}</AnimatePresence>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/product/:id" element={<ProductPage />} />
            <Route path="/status" element={<StatusPage />} />
            <Route path="/portal" element={<CustomerPortal />} />
            <Route path="/orders" element={<Navigate to="/portal" replace />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/bank-pending" element={<BankPending />} />
            <Route path="/payment/crypto" element={<CryptoPay />} />
            <Route path="/reseller/login" element={<ResellerLogin />} />
            <Route path="/reseller" element={<ResellerDashboard />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
          </Routes>
          <CartDrawer />
          <Toaster position="bottom-right" theme="dark" />
        </div>
      </BrowserRouter>
    </CartProvider>
  );
}

export default App;
